/* ==========================================================================
   bsd-back-in-stock.js — "Notify me when it's back" capture
   --------------------------------------------------------------------------
   Rides on the sold-out gate that hearth-parent.js and crate-parent.js already
   ship. It does NOT decide what is sold out — those two files do, from
   Shopify's own `variant.available`, and this one simply follows the line they
   put above the button. One source of truth for the gate; if the gate is ever
   retuned this widget moves with it for free.

   WHY NOT AN APP. Klaviyo's onsite script (klaviyo.js) is already on the store
   via the app embed, but this file does not use it and does not need it: the
   subscription is a single POST to Klaviyo's public client endpoint, which is
   authenticated by the PUBLIC company id and is safe to ship in theme source.
   No app block, no second script, no extra request until someone actually
   types an email.

   WHAT IT POSTS. /client/back-in-stock-subscriptions/ creates the profile and
   the "Subscribed to Back in Stock" event in one call. The variant is
   addressed by its Shopify-synced catalog id — $shopify:::$default:::<id> —
   which is why the Klaviyo catalog has to be in sync for the flow's
   ProductName merge tag to resolve. It is: verified live 12 Sep 2026 against
   FC-EB9060-P, which came back with the right name, SKU and price.

   NO NESTED <form>. This lives INSIDE #hp-form / #cp-form, and a form inside a
   form is dropped by every browser — so the capture is a div, the button is
   type="button", and Enter in the field is caught and swallowed rather than
   posting the buy box.

   PLACEMENT, and read the same note in hearth-parent.js before moving it.
   Under 749px both parent stylesheets give every child of .hp__info /
   .cp__info an explicit `order` and catch strays with a late one, so a node
   appended to the info column sinks to the bottom, far from the button it
   belongs to. It is inserted inside the form, directly after the sold-out
   sentence, and rides the form's own order.
   ========================================================================== */
(function () {
  var cfgEl = document.getElementById('bsd-bis-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.companyId) return;

  /* Which parent page is this? The two buy boxes are different files with the
     same shape; everything below is keyed off the prefix. */
  var P = document.getElementById('hp-form') ? 'hp'
        : document.getElementById('cp-form') ? 'cp' : null;
  if (!P) return;

  function $(id) { return document.getElementById(id); }
  var buyForm = $(P + '-form');
  var atc = $(P + '-atc');
  var vidEl = $(P + '-vid');
  if (!buyForm || !vidEl) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var done = {};      /* variant id -> true, so a second click cannot double-post */
  var wrap, input, button, note, soldEl, observer;
  var lastVid = null;

  /* ---- the capture, built once -------------------------------------------
     Inline styles rather than a stylesheet: this ships as two new files and
     touches no existing CSS, exactly like the sold-out gate it sits under. */
  function build() {
    if (wrap) return wrap;

    wrap = document.createElement('div');
    wrap.id = 'bsd-bis';
    wrap.hidden = true;
    wrap.style.cssText = 'margin:0 0 14px;padding:14px;border:1px solid #212121;background:#f4f3f0';

    var head = document.createElement('p');
    head.id = 'bsd-bis-head';
    head.textContent = cfg.heading;
    head.style.cssText = 'margin:0 0 10px;font-weight:700;font-size:15px;line-height:1.3;color:#212121';

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px';

    input = document.createElement('input');
    input.type = 'email';
    input.id = 'bsd-bis-email';
    input.autocomplete = 'email';
    input.inputMode = 'email';
    input.placeholder = cfg.placeholder;
    input.setAttribute('aria-label', cfg.heading);
    input.style.cssText = 'flex:1 1 190px;min-width:0;padding:11px 12px;border:1px solid #212121;'
      + 'background:#fff;font:inherit;font-size:16px;color:#212121;border-radius:0';

    /* flex-grow on the button too, so when the row wraps on a phone the button
       fills the width under the field rather than sitting two-thirds across. */
    button = document.createElement('button');
    button.type = 'button';           /* never submits the buy box */
    button.id = 'bsd-bis-submit';
    button.textContent = cfg.buttonLabel;
    button.style.cssText = 'flex:1 1 150px;padding:11px 18px;border:1px solid #212121;background:#212121;'
      + 'color:#fff;font:inherit;font-size:15px;font-weight:700;cursor:pointer;border-radius:0';

    note = document.createElement('p');
    note.id = 'bsd-bis-note';
    note.textContent = cfg.consent;
    note.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.4;color:#5b5b5b';

    row.appendChild(input);
    row.appendChild(button);
    wrap.appendChild(head);
    wrap.appendChild(row);
    wrap.appendChild(note);

    /* Directly after the sold-out sentence when there is one, otherwise just
       above the button. Either way inside the form. */
    if (soldEl && soldEl.parentNode === buyForm) {
      buyForm.insertBefore(wrap, soldEl.nextSibling);
    } else if (atc && atc.parentNode === buyForm) {
      buyForm.insertBefore(wrap, atc);
    } else {
      buyForm.appendChild(wrap);
    }

    button.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) {
      /* Enter here must not post the buy box. */
      if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); submit(); }
    });
    input.addEventListener('input', function () {
      if (note.getAttribute('data-state') === 'error') setNote(cfg.consent, '');
    });

    return wrap;
  }

  function setNote(text, state) {
    if (!note) return;
    note.textContent = text;
    note.setAttribute('data-state', state || '');
    note.style.color = state === 'error' ? '#9a1c1c' : (state === 'ok' ? '#1c6b2f' : '#5b5b5b');
  }

  function showForm() {
    build();
    input.style.display = '';
    button.style.display = '';
    button.disabled = false;
    button.textContent = cfg.buttonLabel;
    $('bsd-bis-head').textContent = cfg.heading;
    setNote(cfg.consent, '');
  }

  function showDone() {
    build();
    input.style.display = 'none';
    button.style.display = 'none';
    $('bsd-bis-head').textContent = cfg.successHeading;
    setNote(cfg.successNote, 'ok');
  }

  function submit() {
    var vid = vidEl.value;
    var email = (input.value || '').trim();
    if (!vid) return;
    if (!EMAIL_RE.test(email)) { setNote(cfg.invalid, 'error'); input.focus(); return; }

    button.disabled = true;
    button.textContent = cfg.sendingLabel;

    var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='
      + encodeURIComponent(cfg.companyId);

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: cfg.revision },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } }
          }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      done[vid] = true;
      showDone();
    }).catch(function (err) {
      button.disabled = false;
      button.textContent = cfg.buttonLabel;
      setNote(cfg.failure, 'error');
      if (window.console) console.error('BSD back-in-stock:', err);
    });
  }

  /* ---- follow the gate ---------------------------------------------------
     The sold-out sentence is created lazily by the parent script's first
     render(), which has already run by the time this deferred file executes.
     Belt and braces: if it is not there yet, look again on the next frame. */
  function soldOutNow() {
    if (!soldEl) soldEl = $(P + '-soldout');
    return !!soldEl && soldEl.hidden === false;
  }

  function sync() {
    var vid = vidEl.value;
    if (vid !== lastVid) {
      lastVid = vid;
      if (wrap) { if (done[vid]) showDone(); else { input.value = ''; showForm(); } }
    }
    if (!soldOutNow()) {
      if (wrap) wrap.hidden = true;
      return;
    }
    build();
    if (done[vid]) showDone(); else showForm();
    wrap.hidden = false;
  }

  function watch() {
    soldEl = $(P + '-soldout');
    if (!soldEl) return false;
    if (window.MutationObserver && !observer) {
      observer = new MutationObserver(function () { sync(); });
      observer.observe(soldEl, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true });
    }
    return true;
  }

  /* A change of size, edge, grade, delivery or quantity re-renders the buy box
     on the next tick; re-read the gate after it, not before. */
  var root = document.getElementById(P === 'hp' ? 'hp-root' : 'cp-root') || document;
  ['change', 'input'].forEach(function (ev) {
    root.addEventListener(ev, function () { setTimeout(sync, 0); }, true);
  });

  var tries = 0;
  (function start() {
    if (watch() || tries++ > 20) { sync(); return; }
    if (window.requestAnimationFrame) requestAnimationFrame(start); else setTimeout(start, 32);
  })();
})();
